<template lang="pug">
div
  v-tabs.tab-header(v-model="tabId" @change="onChangeTab" grow)
    template(v-for="(item, index) in tabItems")
      v-tab(:key="index" :id="`tab-${index}`" :disabled="index > 0 && isCreation")
        span {{ item }}
  .py-3
    basic-data(
      v-if="tabId === 0"
      :currentLight="currentLight"
      :isCreation="isCreation"
      @creation="onBasicDataCreate"
      @updateLight="getLightInfo"
    )
    analysis(
      v-if="tabId === 1"
      :currentLight="currentLight"
      :lightId="lightId"
    )
    export(
      v-if="tabId === 2"
      :currentLight="currentLight"
      :lightId="lightId"
    )
  v-overlay(
    :value="isAnalysisLoading"
  )
    v-progress-circular(
      indeterminate
      size="64"
    )
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import urls from '../../../router/urls'

@Component({
  components: {
    BasicData: () => import('./components/BasicData.vue'),
    Analysis: () => import('./components/Analysis.vue'),
    Export: () => import('./components/Export.vue')
  },
})

export default class LightDetails extends Vue {
  @Prop({ type: Boolean, default: false }) isCreation

  tabItems = ['Grunddaten', 'Analyse', 'Export']
  tabId = 0
  lightId = null
  currentLight = null
  isAnalysisLoading = false

  mounted () {
    if (!this.isCreation) {
      this.lightId = this.$route.params.id
    }
  }

  onChangeTab (e) {
    // console.log(e.srcElement.id)
    // this.tabId = 0
    // if (this.tabId === 1) {
    //   this.isAnalysisLoading = true
    //   this.$nextTick(() => {
    //     this.isAnalysisLoading = false
    //   })
    // }
  }

  closeOverlay () {
    this.isAnalysisLoading = false
  }

  onBasicDataCreate (data) {
    this.lightId = data.id
    this.getLightInfo()
  }

  getLightInfo () {
    this.$axios
      .get(urls.ConsultationLight(), { id: this.lightId ?? this.$route.params.id })
      .then(res => {
        this.currentLight = res.data
      })
  }
}
</script>
